import { render, staticRenderFns } from "./standalone-task-item.vue?vue&type=template&id=9d9caf28&"
import script from "./standalone-task-item.vue?vue&type=script&lang=js&"
export * from "./standalone-task-item.vue?vue&type=script&lang=js&"
import style0 from "./standalone-task-item.vue?vue&type=style&index=0&id=9d9caf28&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports